import React, { useEffect, useState } from "react";
import { Dropdown, Menu, Input, Avatar } from "antd";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { getData } from "../../../../../actions/apiCall";
import { constants } from "../../../../../constants/common";
import ProfileCard from "../../../../../components/ContactInfo/ProfileCard";
import { putData } from "../../../../../actions/developer";

interface SearchUsersProps {
    projectId: string;
    taskId: string;
    selectedMember: any;
    onLoad?: () => void;
}

const SearchUsers: React.FC<SearchUsersProps> = ({
    projectId,
    taskId,
    selectedMember,
    onLoad
}) => {
    const [searchValue, setSearchValue] = useState("");
    const [filteredItems, setFilteredItems] = useState<any[]>([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (dropdownOpen && filteredItems.length === 0) {
            getTeams();
        }
    }, [projectId, dropdownOpen]);

    const getTeams = async (search = '') => {
        const resData = await dispatch(getData(`/teams/${projectId}`, { search }));
        if (resData.code == 200) {
            console.log(resData.data);
            setFilteredItems(resData.data);
        }
    }

    const onAssinged = async (teamMemberId) => {
        const resData = await dispatch(putData(`/tasks/${taskId}`, { assignee: teamMemberId }));
        if (resData) {
            if (onLoad) {
                onLoad();
            }
        }
    }

    const menu = (
        <Menu>
            {filteredItems.length > 0 ? (
                filteredItems.map((item, index) => (
                    <Menu.Item key={index} onClick={() => onAssinged(item?._id)}>
                        <ProfileCard
                            size={35}
                            name={constants.GET_FULL_NAME(item?.teamMember)}
                            role={item?.teamMember?.designation}
                            avatarUrl={`${process.env.FILE_URL}${item?.teamMember?.avatar}`}
                        />
                    </Menu.Item>
                ))
            ) : (
                <Menu.Item disabled>No results found</Menu.Item>
            )}
        </Menu>
    );

    const getInitials = (name: string) => {
        let nameArray = name.split(' ');
        if (nameArray.length > 1) {
            return nameArray[0][0] + nameArray[nameArray.length - 1][0];
        }
        return name.split(' ').map(e => e[0]).join('');
    }


    return (
        <Dropdown
            overlay={menu}
            trigger={['click']}
            open={dropdownOpen}
            onOpenChange={(open) => setDropdownOpen(open)}
            placement="bottomLeft"
        >
            {selectedMember?.avatar ? <Avatar src={`${process.env.FILE_URL}${selectedMember?.avatar}`} /> : <Avatar>{getInitials(`${selectedMember?.firstName} ${selectedMember?.lastName}`)}</Avatar>}
        </Dropdown>
    );
};

export default SearchUsers;
